import P2Regular from 'components/typography/P2Regular';
import { DeviceRow } from 'components/tables/data/device/types';

/**
 * Column for internal possessions number.
 */
export default function InternalPossessionsNumberColumn({ data: { internalPossessionsNumber } }: { data: DeviceRow }) {
  return <P2Regular lineClamp={3}>{internalPossessionsNumber}</P2Regular>;
}
